import Loadable from 'loadable-components'
import {LoadingAnimation, ErrorLoading} from 'components/static/loading'

export const mkLoadable = (importStatement) => {
  const defaults = {
    LoadingComponent: LoadingAnimation,
    ErrorComponent: ErrorLoading
  };
  return Loadable(() => importStatement, defaults);
};




// WEBPACK FOOTER //
// ./src/util.js